/**
 * Created by mac on 10/8/20
 */

const AdminDetailsView = cc.Node.extend({
    ctor: function (adminDetails, options) {
        this._super();

        this.adminDetails = adminDetails;

        const size = cleverapps.resolution.getSceneSize();

        this.setContentSize2(options.width, size.height);
        this.setAnchorPoint(0.5, 0.5);

        this.addKeyboardNavigation();

        this.adminDetails.on("reset", this.reset.bind(this), this);

        this.reset();
    },

    wrapWithBg: function (node, options) {
        if (node.innerContent) {
            const styles = cleverapps.styles.AdminDetailsView;
            const paddingTop = styles.bgPadding.y;
            const paddingBottom = styles.bgPadding.y;
            const maxiaturePaddingTop = options && options.maxiaturePaddingTop ? options.maxiaturePaddingTop : 0;

            node.setContentSize2(this.width - 2 * styles.padding.x, Math.max(node.innerContent.height * node.innerContent.scaleY + maxiaturePaddingTop, styles.minHeight) + paddingTop + paddingBottom);
            node.innerContent.setAlignment(node.width / 2, node.height / 2 - maxiaturePaddingTop / 2);
            return node;
        }

        const bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.common_bg);
        node.setAnchorPoint(0.5, 0.5);
        bg.addChild(node);
        bg.innerContent = node;
        return this.wrapWithBg(bg);
    },

    reset: function () {
        if (this.layout) {
            this.layout.removeFromParent();
            this.layout = undefined;
        }

        if (this.status) {
            this.status.removeFromParent();
            this.status = undefined;
        }

        this.createControls();

        const styles = cleverapps.styles.AdminDetailsView;
        const availableWidth = this.calcAvailableWidth();

        const adminLevel = cleverapps.administrator.adminLevels.getActive();

        const maxiatureView = AdminLevelMaxiature.generate(adminLevel);
        this.maxiatureView = this.wrapWithBg(maxiatureView);

        if (adminLevel) {
            const dataView = new AdminDataView(availableWidth);
            this.dataView = this.wrapWithBg(dataView);
            dataView.onReady = this.createListener(this.reshapeContent.bind(this));

            this.eventsView = new AdminLevelFlagsPanel(adminLevel, true);

            const level = adminLevel.getHumanNumber();
            const text = cleverapps.UI.generateOnlyText(`Level: ${level}`, cleverapps.styles.FONTS.ADMIN_DETAILS_VIEW_STATUS_TEXT);

            let currentFlag;
            if (adminLevel.isCurrent()) {
                currentFlag = new cc.Sprite(bundles.admin.frames.current_arrow);
            }

            let tagView;
            if (adminLevel.getTag()) {
                tagView = new AdminLevelTag(adminLevel, true);
            }

            const status = this.status = new cleverapps.Layout([this.eventsView, text, currentFlag, tagView].filter(Boolean), {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.status.margin
            });
            this.maxiatureView.addChild(status);

            if (cleverapps.config.name === "differences") {
                this.enlargeView = this.createEnlargeButton(adminLevel);
                this.maxiatureView.addChild(this.enlargeView);
            }
        } else {
            this.dataView = undefined;
            this.eventsView = undefined;
            this.enlargeView = undefined;
        }

        if (Game.currentGame) {
            const game = Game.currentGame;
            addCleaner(this.maxiatureView, () => {
                game.stop();
            });
        }

        const layout = this.layout = new cleverapps.Layout([this.maxiatureView, this.dataView].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.layout.margin
        });
        this.addChild(layout);

        this.buttons.reset(adminLevel);

        this.reshapeContent();
    },

    calcAvailableWidth: function () {
        const styles = cleverapps.styles.AdminDetailsView;
        return this.width - 2 * styles.padding.x - 2 * styles.bgPadding.x;
    },

    calcMaxiatureHeight: function (siblings) {
        const styles = cleverapps.styles.AdminDetailsView;

        const buttonsTop = this.buttons.getBoundingBox().y + this.buttons.getBoundingBox().height;
        let maxiatureHeight = this.height - styles.paddingTop - 2 * styles.bgPadding.y - buttonsTop - styles.layout.margin;
        maxiatureHeight -= siblings.reduce((height, node) => height + node.height * node.scale + styles.layout.margin + 2 * styles.bgPadding.y, 0);

        return maxiatureHeight;
    },

    reshapeContent: function () {
        const styles = cleverapps.styles.AdminDetailsView;

        if (this.dataView) {
            this.wrapWithBg(this.dataView);
        }

        cleverapps.UI.fitToBox(this.maxiatureView.innerContent, {
            width: this.calcAvailableWidth(),
            height: this.calcMaxiatureHeight([this.dataView].filter(Boolean)) - styles.bgPadding.maxiaturePaddingTop
        });

        this.wrapWithBg(this.maxiatureView, { maxiaturePaddingTop: styles.bgPadding.maxiaturePaddingTop });

        if (this.status) {
            this.status.setAlignment(this.maxiatureView.innerContent.x - this.maxiatureView.innerContent.width * this.maxiatureView.innerContent.scaleX / 2 + this.status.width / 2, styles.status.y);
        }

        if (this.enlargeView) {
            this.enlargeView.setAlignment(styles.enlarge);
        }

        this.layout.reshape();
        this.layout.setAnchorPoint(0.5, 1);
        this.layout.setAlignment(this.width / 2, this.height - styles.paddingTop);
    },

    switchMode: function (mode) {
        this.reset(mode);
    },

    createEnlargeButton: function (adminLevel) {
        const deleteEnlarged = function () {
            if (!this.elarged) {
                return;
            }
            this.elarged.onClick.remove();
            this.elarged.runAction(new cc.RemoveSelf());
            delete this.elarged;
        }.bind(this);

        const resetEnlarged = function () {
            deleteEnlarged();

            const enlarged = this.elarged = AdminLevelMaxiature.generate(adminLevel, { enlarge: true });
            const scene = cleverapps.Scenes.GetRunningScene();
            scene.addChild(enlarged);
            enlarged.setAnchorPoint(0.5, 0.5);
            enlarged.setAlignment(scene.width / 2, scene.height / 2);
            cleverapps.UI.wrap(enlarged);

            const bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_bg);
            const padding = cleverapps.styles.AdminDetailsView.bgPadding.paddingBottom;
            bg.setContentSize(enlarged.width + padding, enlarged.height + padding);
            enlarged.addChild(bg, -1);
            bg.setAlignment(enlarged.width / 2, enlarged.height / 2);

            enlarged.onClick = cleverapps.pointerManager.create(enlarged, {
                swallowEvents: true,
                onOuterTouch: function () {
                    deleteEnlarged();
                }
            });
        }.bind(this);

        if (this.elarged) {
            resetEnlarged();
        }

        return new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.editor,
            onClicked: resetEnlarged
        });
    },

    createControls: function () {
        if (this.buttonsWithBg) {
            this.buttonsWithBg.removeFromParent();
            this.buttonsWithBg = undefined;
            this.buttons = undefined;
        }

        this.buttons = new AdminDetailControls();
        this.buttonsWithBg = this.wrapWithBg(this.buttons);
        this.addChild(this.buttonsWithBg);
        this.buttonsWithBg.setAlignment(cleverapps.styles.AdminDetailsView.buttons);
    },

    addKeyboardNavigation: function () {
        const execAction = function (action) {
            cleverapps.focusManager.display({
                focus: "hotKeyPress",
                action
            });
        };

        cleverapps.inputDispatcher.on("keypressed", (key) => {
            if (key === InputDispatcher.KEY.left && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl)) {
                execAction((f) => {
                    AdminNavigation.nextEpisode(AdminNavigation.LEFT, f);
                });
            } else if (key === InputDispatcher.KEY.right && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl)) {
                execAction((f) => {
                    AdminNavigation.nextEpisode(AdminNavigation.RIGHT, f);
                });
            } else if (key === InputDispatcher.KEY.enter && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl)) {
                cleverapps.administrator.adminLevels.getActive().editLevel();
            } else if (key === InputDispatcher.KEY.h) {
                const activeLevel = cleverapps.administrator.adminLevels.getActive();
                if (activeLevel) {
                    activeLevel.toggleHard();
                }
            } else if (key === InputDispatcher.KEY.left) {
                execAction((f) => {
                    AdminNavigation.nextLevel(AdminNavigation.LEFT, f);
                });
            } else if (key === InputDispatcher.KEY.right) {
                execAction((f) => {
                    AdminNavigation.nextLevel(AdminNavigation.RIGHT, f);
                });
            } else if (key === InputDispatcher.KEY.enter) {
                execAction((f) => {
                    LevelManager.getInstance().playLevel(f);
                });
            }
        }, this);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ADMIN_DETAILS_VIEW_STATUS_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.ADMIN_TEXT_COLOR
    }
});

cleverapps.styles.AdminDetailsView = {
    minHeight: 50,

    padding: {
        x: 10,
        y: 0
    },

    bgPadding: {
        x: 10,
        y: 20,

        paddingBottom: 40,

        maxiaturePaddingTop: 40
    },

    events: {
        x: { align: "right", dx: 0 },
        y: { align: "bottom", dy: 0 }
    },

    enlarge: {
        x: { align: "right", dx: 5 },
        y: { align: "top", dy: 25 }
    },

    status: {
        y: { align: "top", dy: -10 },
        margin: 10
    },

    buttons: {
        x: { align: "center" },
        y: { align: "bottom", dy: 15 }
    },

    paddingTop: 15,

    layout: {
        margin: 10
    }
};
